import { render } from "./AdministrativeInfoCard.vue?vue&type=template&id=7e8e5767"
import script from "./AdministrativeInfoCard.vue?vue&type=script&lang=js"
export * from "./AdministrativeInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__